import React, { useEffect } from "react";
import LOGO from "../assets/images/logo-space.png";
import { Link } from "react-router-dom";
import { useGetImageDesignMutation } from "../services/PortfolioSerivce/PortfolioService";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import "../styles/KeyFrameGallery.scss";

const GalleryArtWork = () => {
  const [getImageDesign, result_image_design] = useGetImageDesignMutation();

  const fnGetImageDesign = async () => {
    try {
      await getImageDesign().unwrap();
    } catch (err) {
      return;
    }
  };

  useEffect(() => {
    fnGetImageDesign();
  }, []);

  return (
    <div className="flex flex-col w-full items-center overflow-hidden relative mb-[100px]">
      <div className="flex flex-col max-w-[1280px] w-full ">
        <div className="flex flex-row justify-between my-[25px] items-center">
          <Link to="/">
            <div className="flex flex-row gap-[10px]">
              <img
                src={LOGO}
                className="w-[50px] rounded-[10px] hover:scale-110 duration-200"
              />
              <div>
                <p className="mb-0 text-base font-bold text-custom-gray-100">
                  WATCHARAPOL
                </p>
                <p className="mb-0 text-base text-custom-gray-75">
                  Web Profile
                </p>
              </div>
            </div>
          </Link>

          <p className="mb-0 text-[12px] font-medium text-custom-gray-100 text-right xs:hidden">
            Create from imagination and past experiences
            <br />
            Then I displayed it in my little space
          </p>
        </div>

        {result_image_design.isLoading ? (
          <>
            <div className="h-[200px] w-full flex flex-col justify-center items-center">
              <div className="h-[60px] w-[60px] rounded-[100px] border-solid border-[7px] border-custom-primary-25  border-b-custom-secondary-50 animate-spin"></div>
            </div>
          </>
        ) : (
          <>
            <div className="flex-col flex items-center">
              {" "}
              <div className="flex-col flex items-center fixed z-0">
                <h1
                  className=" text-[150px] font-bold text-custom-primary-100 mb-[-40px] mt-[-50px] fade-in-text 
                ss:text-[50px] xs:text-[70px] sm:text-[120px]
                ss:mt-[0px] xs:mt-[-10px] sm:mt-[-20px]
                ss:mb-[-10px] xs:mb-[-20px] sm:mb-[-30px]
                "
                >
                  Gallery
                </h1>
                <p className="fade-in-text2 ss:text-[10px] xs:text-[12px] sm:text-[14px]">
                  My artwork space
                </p>
              </div>
              <div className="relative flex flex-col w-full sm:absolute">
                <div
                  className={`absolute z-[-1] h-[800px] w-[800px] 
                border-solid  border-[1px]
                rounded-full 
                top-[-650px] m-auto left-0 right-0 sm:left-[calc(100%_-_800px)] sm:right-[calc(100%_-_800px)]
                line-circle
                border-custom-primary-25 border-t-custom-secondary-50 border-r-custom-secondary-50
                `}
                ></div>
                <div
                  className="absolute z-[-1] h-[400px] w-[400px] 
                border-solid border-[1px] rounded-full 
                top-[30px] m-auto left-0 right-0 ss:left-[calc(100%_-_400px)] ss:right-[calc(100%_-_400px)]
                line-circle-small 
                border-custom-primary-25 border-t-custom-secondary-50 border-r-custom-secondary-50
                "
                ></div>
                <div
                  className="absolute z-[-1] h-[400px] w-[400px] 
                border-solid border-[1px] rounded-full 
                top-[90px] m-auto left-0 right-0 ss:left-[calc(100%_-_400px)] ss:right-[calc(100%_-_400px)]
                border-custom-primary-25 border-t-custom-secondary-50 border-r-custom-secondary-50
                line-circle-small2
                "
                ></div>
                <div
                  className="absolute z-[-1] w-[0px] 
                border-solid border-[0px] border-l-[1px] 
                 border-custom-primary-25
                 m-auto left-0 right-0 top-[-250px] 
                 line-center-down
                "
                ></div>
              </div>
            </div>

            <div className="mt-[180px] z-10 w-full ss:mt-[100px] xs:mt-[120px] sm:mt-[140px]">
              <div className="h-[40px] bg-gradient-to-t from-custom-secondary-50"></div>
              {result_image_design.isError ? (
                <>
                  <div className="h-[200px] flex flex-col justify-center items-center bg-custom-secondary-50">
                    <p className="text-custom-gray-75 tracking-[5px] text-[14px]">
                      No Data
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{
                      199: 1,
                      200: 2,
                      576: 2,
                      768: 3,
                      992: 4,
                      1200: 5,
                    }}
                    className="bg-custom-secondary-50 pt-[10px] min-h-[300px]"
                  >
                    <Masonry gutter="20px">
                      {result_image_design.data?.data?.map((item) => (
                        <>
                          <img
                            key={item._id}
                            src={item.url_image}
                            className="rounded-[15px]"
                          />
                        </>
                      ))}
                    </Masonry>
                  </ResponsiveMasonry>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GalleryArtWork;
